"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var schemaMethods_1 = require("../schemaMethods");
var ValidationResult_1 = require("./ValidationResult");
var getValidations_1 = require("./getValidations");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
var validPropFunction_1 = require("./validPropFunction");
var validFunction_1 = require("./validFunction");
var IOptions_1 = require("../WrappedProperty/IOptions");
var getRuleMessage_1 = require("./getRuleMessage");
var calcFunction_1 = require("./calcFunction");
var validationMessages_1 = require("../validationMessages");
var aggregateFunction_1 = require("./aggregateFunction");
var schemaProxy_1 = require("./schemaProxy");
/**
 * funkcja tworząca property wyliczające wartośc pola schematu
 *
 * @param {*} $schema
 * @param {*} internal
 * @param {string} field
 * @returns
 */
function wrapSchemaProp($schema, internal, field) {
    var schema = internal.schema;
    internal.needsCalcArgs = true;
    var v = schema[field];
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    // console.log(`create valid function`, field, v, internal.parent);
    if (schema.cache === undefined) {
        schema.cache = {};
    }
    var ff = schema.cache["schema_" + field];
    if (ff === undefined) {
        ff = validPropFunction_1.default(v);
        // console.log('calc func', ff.toString());
        schema.cache["schema_" + field] = ff;
    }
    Object.defineProperty($schema, field, {
        enumerable: true,
        get: function () {
            try {
                return ff.apply(internal.parentModel, internal.calcargs);
            }
            catch (_a) {
                return undefined;
            }
        }
    });
}
/**
 * funkcja tworząca wyliczalne property dla okreslonych pól schematu
 *
 * @param {*} $schema wynikowy schemat w którym tworzone są poperty
 * @param {*} internal dane wewnętrzne, m.in. schemat wejsciowy
 * @param {string} type jaki typ property powoduje że jest ono statyczne,
 * w przeciwnym przypadku traktowane jest jako wyliczalne
 * @param {string[]} props jakie pola schematu obudować
 */
function wrapSchemaProps($schema, internal, type, props) {
    for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
        var field = props_1[_i];
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp($schema, internal, field);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
/**
 * funkcja walidująca tabele, nie używana
 *
 * @param {JSONSchema} schema
 * @param {any[]} data
 * @param {string} [path='']
 * @param {IExtendedValidateOptions} options
 * @param {*} [parent]
 * @param {*} [key]
 * @returns {(IValidationError | null)}
 */
function validateTable(schema, data, path, options, parent, key) {
    if (path === void 0) { path = ''; }
    var result = [];
    if (schema.minItems !== undefined) {
        if (data.length < schema.minItems) {
            var err = {
                validation: 'minItems',
                expected: schema.minItems,
                value: data.length,
                path: path
            };
            if (options.breakOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    if (schema.maxItems !== undefined) {
        if (data.length > schema.maxItems) {
            var err = {
                validation: 'maxItems',
                expected: schema.maxItems,
                value: data.length,
                path: path
            };
            if (options.breakOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    return options.breakOnFirstError ? null : result;
}
/**
 * dodanie błedu
 *
 * @param {IExtendedValidateOptions} options
 * @param {string} path
 * @param {string} validation
 * @param {*} value
 * @param {string} [message]
 * @returns {IValidationError}
 */
/**
 * funkacja walidująca pojedyńcze pole
 *
 * @param {JSONSchema} schema schemat pola
 * @param {*} data aktualna wartość
 * @param {string} [path=''] ścieżka do pola
 * @param {IExtendedValidateOptions} options opcje walidacji
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @param {*} [parentProxy] obiekt nadrzędny obudowany schemaProxy
 * @returns {(IValidationError | null)} błąd w polu
 */
function validateField(schema, data, path, options, parent, key, parentProxy) {
    if (path === void 0) { path = ''; }
    var schemaIsNumber = false;
    var dataIsNumber = false;
    var $schema = {};
    var internal = { schema: schema };
    var err = null;
    var setError = function (validation, expected, value) {
        err = {
            path: path,
            validation: validation,
            expected: expected !== undefined
                ? expected
                : $schema[validation] === undefined
                    ? schema[validation]
                    : $schema[validation],
            value: value || data
        };
        if (!options.disableMessages) {
            err.message = getRuleMessage_1.getRuleMessage({ options: options, schema: schema }, validation, data, $schema);
        }
        options.errors.push(err);
        if (options.breakOnFirstError) {
            return true;
        }
        return false;
    };
    var funcs = getValidations_1.getValidations(schema, schema, false);
    switch (schema.type) {
        case 'integer':
        case 'number':
        case 'money':
            wrapSchemaProps($schema, internal, 'number', [
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum',
                'precision'
            ]);
            break;
        case 'string':
            wrapSchemaProps($schema, internal, 'number', ['maxLength', 'minLength']);
            wrapSchemaProps($schema, internal, 'number', ['minimum', 'maximum', 'exclusiveMaximum', 'exclusiveMinimum']);
            break;
        case 'array':
            wrapSchemaProps($schema, internal, 'number', ['maxItems', 'minItems', 'length']);
            break;
    }
    if (schema.enum !== undefined) {
        if (!Array.isArray(schema.enum)) {
            wrapSchemaProp($schema, internal, 'enum');
        }
        else {
            $schema.enum = schema.enum;
        }
    }
    if (schema.required !== undefined &&
        schema.type !== 'object' &&
        (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
        schema.fieldRequired = schema.required;
    }
    wrapSchemaProps($schema, internal, 'boolean', ['fieldRequired', 'disabled']);
    wrapSchemaProps($schema, internal, 'string', ['title', 'shortTitle', 'description']);
    var validFunc = null;
    if (schema.validFunc) {
        internal.needsCalcArgs = true;
        if (schema.cache === undefined) {
            schema.cache = {};
        }
        var tempFunc_1 = schema.cache["schema_validFunc"];
        if (tempFunc_1 === undefined) {
            tempFunc_1 = validFunction_1.default(schema, schema.validFunc, false, process.env.NODE_ENV === 'development' && schema.debug);
        }
        validFunc = function (value) {
            var funcvalue = tempFunc_1.apply(internal.parentModel, internal.calcargs);
            if (funcvalue === true || funcvalue === undefined) {
                return null;
            }
            if (funcvalue === false) {
                return 'validFunc';
            }
            return funcvalue;
        };
        funcs.push(validFunc);
    }
    internal.calcFunction = null;
    internal.aggregateFunction = null;
    internal.calcValue = undefined;
    if (options.validateCalculations) {
        if (schema.calc) {
            internal.validateCalculations = true;
            internal.needsCalcArgs = true;
            if (schema.cache === undefined) {
                schema.cache = {};
            }
            var ff = schema.cache.calcFunction;
            if (ff === undefined) {
                schema.cache.calcFunction = ff = calcFunction_1.default(schema, false, false, false);
            }
            internal.calcFunction = ff;
        }
        else if (schema.aggregate) {
            internal.validateCalculations = true;
            internal.needsCalcArgs = true;
            if (schema.cache === undefined) {
                schema.cache = {};
            }
            var ff = schema.cache.calcFunction;
            if (ff === undefined) {
                schema.cache.aggregateFunction = ff = aggregateFunction_1.default(schema, false, false, false);
            }
            internal.aggregateFunction = ff;
        }
    }
    var obj = {
        $key: key,
        $model: data,
        $parent: parent
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    internal.parent = parentProxy;
    if (internal.needsCalcArgs) {
        var paramData = [{}, {}, {}, {}, options.external, options.schemaMethods, obj];
        if (parentProxy) {
            // używaj proxy do wyliczeń
            paramData[0] = options.$rootProxy;
            if (parentProxy.$parent) {
                paramData[1] = parentProxy.$parent;
                if (parentProxy.$parent.$parent) {
                    paramData[2] = parentProxy.$parent.$model;
                    if (parentProxy.$parent.$parent.$parent) {
                        paramData[3] = parentProxy.$parent.$parent.$model;
                    }
                }
            }
            internal.calcargs = paramData;
            internal.parentModel = parentProxy;
        }
        else {
            // używaj zwykłego modelu
            paramData[0] = obj.$root.$model;
            if (parent && parent.$parent) {
                paramData[1] = parent.$parent.$model;
                if (parent.$parent.$parent) {
                    paramData[2] = parent.$parent.$parent.$model;
                    if (parent.$parent.$parent.$parent) {
                        paramData[3] = parent.$parent.$parent.$parent.$model;
                    }
                }
            }
            internal.calcargs = paramData;
            internal.parentModel = parent ? parent.$model : {};
        }
    }
    // oblicz wartość
    if (!$schema.disabled) {
        if (internal.validateCalculations) {
            if (internal.calcFunction) {
                internal.calcValue = internal.calcFunction.apply(internal.parentModel, internal.calcargs);
            }
            else if (internal.aggregateFunction) {
                internal.calcValue = internal.aggregateFunction.apply(internal.parentModel, internal.calcargs);
            }
        }
        // console.log(JSON.stringify(schema));
        if (schema.type === 'number' || schema.type === 'money') {
            schemaIsNumber = true;
            if ($schema.fieldRequired && (data === undefined || data === null)) {
                if (setError('required')) {
                    return err;
                }
            }
            if (data !== undefined) {
                if (typeof data !== 'number') {
                    if (setError('type', schema.type, typeof data)) {
                        return err;
                    }
                }
                else {
                    dataIsNumber = true;
                }
            }
        }
        else if (schema.type === 'int' || schema.type === 'integer') {
            schemaIsNumber = true;
            if ($schema.fieldRequired && (data === undefined || data === null)) {
                if (setError('required')) {
                    return err;
                }
            }
            if (data !== undefined) {
                if (typeof data !== 'number') {
                    if (setError('type', schema.type, typeof data)) {
                        return err;
                    }
                    // result.valid = false;
                }
                else {
                    if (data % 1 !== 0) {
                        // result.valid = false;
                        if (setError('type', schema.type, 'float')) {
                            return err;
                        }
                    }
                    else {
                        dataIsNumber = true;
                    }
                }
            }
        }
        if (schemaIsNumber) {
            if (dataIsNumber) {
                if (internal.validateCalculations && data !== internal.calcValue) {
                    if (setError('calc', internal.calcValue)) {
                        return err;
                    }
                }
                for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
                    var func = funcs_1[_i];
                    var res = func(data, $schema);
                    if (res) {
                        if (setError(res)) {
                            return err;
                        }
                    }
                }
            }
        }
        else {
            if (schema.type === 'string') {
                if ($schema.fieldRequired && (data === undefined || data === null || data === '')) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (typeof data !== 'string') {
                        if (setError('type', schema.type)) {
                            return err;
                        }
                    }
                    else {
                        // sprawdza czy wynik jest identyczny
                        if (internal.validateCalculations && data !== internal.calcValue) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (var _a = 0, funcs_2 = funcs; _a < funcs_2.length; _a++) {
                            var func = funcs_2[_a];
                            var res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'boolean') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== undefined && typeof data !== 'boolean') {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && data !== internal.calcValue) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (var _b = 0, funcs_3 = funcs; _b < funcs_3.length; _b++) {
                            var func = funcs_3[_b];
                            var res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'array') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== undefined && data !== null && !Array.isArray(data)) {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && JSON.stringify(data) !== JSON.stringify(internal.calcValue)) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (var _c = 0, funcs_4 = funcs; _c < funcs_4.length; _c++) {
                            var func = funcs_4[_c];
                            var res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                        var length_1 = $schema.length;
                        if (length_1 !== undefined && data !== null) {
                            if (data.length !== length_1) {
                                if (setError('length', length_1)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
            else if (schema.type === 'object') {
                if ($schema.fieldRequired && (data === undefined || data === null)) {
                    if (setError('required')) {
                        return err;
                    }
                }
                if (data !== undefined) {
                    if (data !== null && typeof data !== 'object') {
                        if (setError('type', schema.type, typeof data)) {
                            return err;
                        }
                    }
                    else {
                        if (internal.validateCalculations && JSON.stringify(data) !== JSON.stringify(internal.calcValue)) {
                            if (setError('calc', internal.calcValue)) {
                                return err;
                            }
                        }
                        for (var _d = 0, funcs_5 = funcs; _d < funcs_5.length; _d++) {
                            var func = funcs_5[_d];
                            var res = func(data, $schema);
                            if (res) {
                                if (setError(res)) {
                                    return err;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return err;
}
/**
 * wewnętrzna funkcja walidaująca
 *
 * @param {JSONSchema} schema schemat pola
 * @param {*} data aktualna wartość
 * @param {string} path ścieżka do pola
 * @param {IExtendedValidateOptions} options opcje walidacji
 * @param {*} [parent] obiekt nadrzędny
 * @param {*} [key] nazwa pola
 * @param {*} [parentProxy] obiekt nadrzędny obudowany schemaProxy
 */
function _validate(schema, data, path, options, parent, key, parentProxy) {
    var obj = {
        $key: key,
        $model: data,
        $parent: parent,
        $parent2: parent ? parent.$parent : {},
        $parent3: parent && parent.$parent ? parent.$parent.$parent : {}
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
        // tworzenie proxy dla nadrzędnego elementu
        if (!options.$rootProxy) {
            // wyłaczam Proxy, zobaczymy co się stanie
            options.$rootProxy = parentProxy = schemaProxy_1.default(options.$rootSchema, obj.$root.$model, options.external);
        }
    }
    parentProxy = parentProxy || options.$rootProxy;
    if (schema.type === 'object') {
        validateField(schema, data, path, options, parent, key, parentProxy);
        var required = schema.required || [];
        if (schema.properties && data) {
            var propParentProxy = parentProxy ? parentProxy[key] : null;
            for (var keyprop in schema.properties) {
                // for (let key of schema.$keys) {
                if (schema.properties.hasOwnProperty(keyprop)) {
                    var element = schema.properties[keyprop];
                    var value = data[keyprop];
                    if (required.indexOf(keyprop) > -1 && element.fieldRequired === undefined) {
                        element.fieldRequired = true;
                    }
                    /*
                              if (element.fieldRequired || required.indexOf(key) > -1) {
                                  if (value === undefined
                                      || (element.type === 'string' && !value)
                                      //|| (element.type === 'integer' && !value)
                                  ) {
                                      // result.valid = false;
                                      result.errors.push({
                                          validation: 'required',
                                          path: path === '' ? key : path + '.' + key
                                      });
                                      if (exitOnFirstError) {
                                          continue;
                                      }
                                  }
                              }
                              */
                    // if (value !== undefined) {
                    _validate(element, value, path === '' ? keyprop : path + '.' + keyprop, options, obj, keyprop, propParentProxy);
                    // }
                }
            }
        }
    }
    else if (schema.type === 'array') {
        validateField(schema, data, path, options, parent, key, parentProxy);
        // uniqueItems
        // contains
        var propParentProxy = parentProxy ? parentProxy[key] : null;
        var items = schema.items;
        if (items && data) {
            var subobj = {
                $key: 0,
                $model: null,
                $parent: obj,
                $parent2: obj.$parent,
                $parent3: obj.$parent2,
                $root: obj.$root
            };
            for (var i = 0; i < data.length; i++) {
                /*
                const subobj = {
                  $key: i,
                  $model: data[i],
                  $parent: obj,
                  $parent2: obj.$parent,
                  $parent3: obj.$parent ? obj.$parent.$parent : {},
                  $root: obj.$root
                };
                */
                subobj.$key = i;
                subobj.$model = data[i];
                var res = _validate(items, data[i], path + '[' + i + ']', options, subobj, i, propParentProxy);
            }
        }
    }
    else {
        validateField(schema, data, path, options, parent, key, parentProxy);
    }
}
/**
 * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
 * @param data dane do sprawdzenia
 * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
 * @param path sciezka startowa pola, przy pominięciu ustawia pustą
 */
/**
 * Sprawdza poprawność danych według schematu i zawartej w nim walidacji
 *
 * @export
 * @param {JSONSchema} schema schemat danych
 * @param {*} data dane do sprawdzenia
 * @param {IValidateOptions} [options] opcje walidacji
 * @param {string} [path=''] aktualna ścieżka, używana potem w wynikach jako ścieżka bazowa
 * @returns {ValidationResult} wynik walidacji
 */
function validate(schema, data, options, path) {
    if (path === void 0) { path = ''; }
    var options2 = {
        schemaMethods: schemaMethods_1.default,
        validateCalculations: false,
        validationMessages: validationMessages_1.default,
        warningMessages: validationMessages_1.default,
        disableMessages: false,
        breakOnFirstError: true,
        errors: [],
        // fixData: false,
        external: {},
        $rootProxy: null,
        $rootSchema: null
        // disabledFields: {}
    };
    if (options) {
        IOptions_1.mergeOptions(options2, options);
    }
    if (schema.$parent === undefined) {
        if (Array.isArray(schema)) {
            schema = fixAndMergeSchema_1.default(schema);
        }
        else {
            schema = fixAndMergeSchema_1.default([schema]);
        }
    }
    if (schema.$options) {
        if (schema.$options.validationMessages) {
            options2.validationMessages = Object.assign({}, options2.validationMessages, schema.$options.validationMessages);
        }
        if (schema.$options.warningMessages) {
            options2.warningMessages = Object.assign({}, options2.warningMessages, schema.$options.warningMessages);
        }
    }
    options2.$rootSchema = schema;
    options2.$rootProxy = null;
    // const modelProxy = schemaProxy(schema, data, options2.external);
    _validate(schema, data, path || '', options2, null, null);
    var result = new ValidationResult_1.default();
    result.errors = options2.errors;
    result.valid = result.errors.length === 0;
    return result;
}
exports.default = validate;
//# sourceMappingURL=validate.js.map